import script from "./ProductListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductListItem.vue?vue&type=script&setup=true&lang=ts"

import "./ProductListItem.vue?vue&type=style&index=0&id=0a850d52&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a850d52"]])

export default __exports__